import { axios } from '@zyf2e/adapt';
import { SPECIALIST, SPECIALIST_API, FAST_INQUIRY_API } from '@/constant';
import {
  IgetClinicHomePage,
  IgetSpecialistDetailParam,
  IgetHotCity,
  IgetChildParam,
  IpostFollowSpecialistData,
  IpostUnfollowSpecialistData,
  IspecialistDetail,
  IgetDepartmentList,
  IgetSearchConditionList,
  IgetDoctorSearchParam,
  IgetDoctorSearch,
  IgetFollowDoctorListParam,
  IgetFollowDoctorList,
  IpostStartConsultParam,
  IpostStartConsult,
  IpostPayConsultParam,
  IpostPayConsult,
  IgetApiDoctorRecommendFamousDoctors,
  IgetChildResult,
  IgetIMRecommendDoctorList,
  IgetIMRecommendDoctorListParam,
  IgetLocationCity,
  IgetHospitalTypeList,
  IgetDoctorQueryHospitalList,
  IgetDoctorQueryHospitalListParam,
  IgetSearchHospitalDoctorSearchParam,
  IgetDoctorQueryHospitalListHospitalList,
  IgetSearchGetDepartmentMarking,
  IgetConsultCoinRechargeInfo,
  IgetConsultCoinRechargeInfoParam,
  IgetSearchGetfollowSpecialistResult,
  IgetDoctorRecommendFamousDoctorsParam,
  IgetConsultQueryQuickConsultStatus,
  IPostConsultStartConsultParam,
  IPostConsultStartConsult,
  IPostConsultStartQuickConsultParam,
  IPostConsultStartQuickConsult,
  IgetSpecialistPacksParams,
  IgetSpecialistPacksResult,
  IGetEquityPackDetailParams,
  IGetEquityPackDetailResult,
  IgetSpecialistPaidPacksParams,
  IgetSpecialistPaidPacksResult
} from '@/store/specialist/index.d';

import { ActionContext } from 'vuex';
import { getStoreAccessors } from 'vuex-typescript';

type SpecialistContext = ActionContext<IspecialistState, {}>;

interface IspecialistState {
  specialist: IspecialistDetail;
  searchText: string;
  searchHistory: string[];
}

export const specialistPersistField = ['searchText', 'searchHistory'];

const specialist = {
  namespaced: true,
  state: {
    specialist: {
      avatar: '',
      followed: false,
      name: '',
      jobTitle: '',
      hospitalTag: '',
      hospital: '',
      department: '',
      specialties: '',
      doctorTagEnum: [],
      price: 0,
      amount: '0',
      coin: 0,
      consultService: false,
      resume: ''
    },

    searchText: '',
    searchHistory: []
  },
  actions: {
    getCoinRechargeInfo(
      context: SpecialistContext,
      params: IgetConsultCoinRechargeInfoParam
    ): Promise<IgetConsultCoinRechargeInfo> {
      return axios.get(SPECIALIST_API.GET_COIN_RECHARGE_INFO, { params });
    },
    /**
     * 获取专家问诊首页
     */
    getHomePageInfo(): Promise<IgetClinicHomePage> {
      return axios.get(SPECIALIST_API.GET_CLINIC_HOME_PAGE);
    },
    followSpecialist(
      context: SpecialistContext,
      data: IpostFollowSpecialistData
    ): Promise<IgetSearchGetfollowSpecialistResult> {
      return axios.post(SPECIALIST_API.FOLLOW, data);
    },
    unfollowSpecialist(context: SpecialistContext, data: IpostUnfollowSpecialistData): Promise<void> {
      return axios.post(SPECIALIST_API.UNFOLLOW, data);
    },

    searchSpecialist(context: SpecialistContext, params: IgetDoctorSearchParam): Promise<IgetDoctorSearch> {
      return axios.get(SPECIALIST_API.SEARCH_DOCTORS, { params });
    },
    departmentDoctorSearch(context: SpecialistContext, params: IgetDoctorSearchParam): Promise<IgetDoctorSearch> {
      return axios.get(SPECIALIST_API.DEPARTMENT_DOCTOR_SEARCH, { params });
    },

    groupDoctorSearch(context: SpecialistContext, params: IgetDoctorSearchParam): Promise<IgetDoctorSearch> {
      return axios.get(SPECIALIST_API.GROUP_DOCTOR_SEARCH, { params });
    },

    // 获取城市列表
    getRegionList(context: SpecialistContext, params: IgetChildParam): Promise<IgetChildResult[]> {
      return axios.get(SPECIALIST_API.GET_REGION, { params });
    },

    getLocation(context: SpecialistContext, { latitude, longitude }: Partial<Coordinates>): Promise<IgetLocationCity> {
      return axios.get(SPECIALIST_API.GET_LOCATION, { params: { location: [latitude, longitude].join(',') } });
    },

    // 获取热门城市
    getHotCity(): Promise<IgetHotCity> {
      return axios.get(SPECIALIST_API.GET_HOT_CITY);
    },

    // 获取科室列表
    getDepartmentList(): Promise<IgetDepartmentList> {
      return axios.get(SPECIALIST_API.GET_DEPARTMENTS);
    },

    // 搜索条件列表
    getSearchConditionList(): Promise<IgetSearchConditionList> {
      return axios.get(SPECIALIST_API.GET_FILTER_CONDITIONS);
    },
    getHospitalsType(): Promise<IgetHospitalTypeList> {
      return axios.get(SPECIALIST_API.GET_HOSPITALS_TYPE);
    },
    getFollowedSpecialistList(
      context: SpecialistContext,
      params: IgetFollowDoctorListParam
    ): Promise<IgetFollowDoctorList> {
      return axios.get(SPECIALIST_API.GET_FOLLOW_SPECIALIST_LIST, { params });
    },
    startConsult(context: SpecialistContext, data: IpostStartConsultParam): Promise<IpostStartConsult> {
      return axios.post(SPECIALIST_API.START_CONSULT, data);
    },
    async payConsult(context: SpecialistContext, data: IpostPayConsultParam): Promise<void> {
      const { success } = (await axios.post(SPECIALIST_API.PAY_CONSULT, data)) as IpostPayConsult;
      if (!success) {
        throw new Error();
      }
    },

    async fastInquiryPay(context: SpecialistContext, data: IpostPayConsultParam): Promise<void> {
      const { success } = (await axios.post(FAST_INQUIRY_API.PAY_CONSULT, data)) as IpostPayConsult;
      if (!success) {
        throw new Error();
      }
    },

    async fastInquiryCancelConsult(context: SpecialistContext, data: IpostPayConsultParam): Promise<void> {
      return axios.post(FAST_INQUIRY_API.CANCEL_CONSULT, data);
    },

    // 最新快速问诊单状态
    async fetchGetConsultQueryQuickConsultStatus(
      context: SpecialistContext,
      params: IPostConsultStartQuickConsultParam
    ) {
      return axios.get<IgetConsultQueryQuickConsultStatus>(FAST_INQUIRY_API.GET_PAY_INFO, { params });
    },

    getRecommendSpecialists(
      context: SpecialistContext,
      params: IgetDoctorRecommendFamousDoctorsParam
    ): Promise<IgetApiDoctorRecommendFamousDoctors> {
      return axios.get(SPECIALIST_API.GET_RECOMMEND_SPECIALIST, { params });
    },

    getHospitalList(
      context: SpecialistContext,
      params: IgetDoctorQueryHospitalListParam
    ): Promise<IgetDoctorQueryHospitalList> {
      return axios.get(SPECIALIST_API.GET_HOSPITAL_LIST, { params });
    },

    getIMRecommendSpecialists(
      context: SpecialistContext,
      params: IgetIMRecommendDoctorListParam
    ): Promise<IgetIMRecommendDoctorList> {
      return axios.get(SPECIALIST_API.GET_IM_RECOMMEND_SPECIALIST, { params });
    },

    getHospitalDeptSpecialists(
      context: SpecialistContext,
      params: IgetSearchHospitalDoctorSearchParam
    ): Promise<IgetDoctorSearch> {
      return axios.get(SPECIALIST_API.GET_HOSPITAL_DEPT_SPECIALIST, { params });
    },

    getHospitalDetail(
      context: SpecialistContext,
      params: { hospitalId: number }
    ): Promise<IgetDoctorQueryHospitalListHospitalList> {
      return axios.get(SPECIALIST_API.GET_HOSPITAL_DETAIL, { params });
    },

    getHospitalDepts(
      context: SpecialistContext,
      params: { hospitalId: number }
    ): Promise<IgetSearchGetDepartmentMarking> {
      return axios.get(SPECIALIST_API.GET_HOSPITAL_DEPARTMENTS, { params });
    },

    // #region 需要使用 commit
    async getSpecialistDetail(context: SpecialistContext, params: IgetSpecialistDetailParam): Promise<void> {
      const specialistDetail = (await axios.get(SPECIALIST_API.GET_DETAIL, { params })) as IspecialistDetail;
      commitSetSetSpecialistDetail(context, specialistDetail);
    },
    // #endregion

    placeOrder(context: SpecialistContext, params: IPostConsultStartConsultParam): Promise<IPostConsultStartConsult> {
      return axios.post(SPECIALIST_API.PLACE_ORDER, params);
    },

    placeFastInquiryOrder(
      context: SpecialistContext,
      params: IPostConsultStartQuickConsultParam
    ): Promise<IPostConsultStartQuickConsult> {
      return axios.post(FAST_INQUIRY_API.PLACE_ORDER, params);
    },

    getSpecialistPacks(
      context: SpecialistContext,
      params: IgetSpecialistPacksParams
    ): Promise<IgetSpecialistPacksResult> {
      return axios.get(SPECIALIST_API.GET_SPECIALIST_PACKS, { params });
    },

    getSpecialistPaidPacks(
      context: SpecialistContext,
      params: IgetSpecialistPaidPacksParams
    ): Promise<IgetSpecialistPaidPacksResult> {
      return axios.get(SPECIALIST_API.GET_SPECIALIST_PAID_PACKS, { params });
    },

    getEquityPackDetail(
      context: SpecialistContext,
      params: IGetEquityPackDetailParams
    ): Promise<IGetEquityPackDetailResult> {
      return axios.get(SPECIALIST_API.GET_EQUITY_PACK_DETAIL, { params });
    },

    startConsultV2(context: SpecialistContext, data: IpostStartConsultParam): Promise<IpostStartConsult> {
      return axios.post(SPECIALIST_API.START_CONSULT_V2_1, data);
    }
  },
  mutations: {
    setSpecialistDetail(state: IspecialistState, partialSpecialistDetail: Partial<IspecialistDetail>) {
      Object.assign(state.specialist, partialSpecialistDetail);
    },
    updateSpecialistDetail(state: IspecialistState, specialistDetail: Partial<IspecialistDetail>) {
      Object.assign(state.specialist, specialistDetail);
    },
    setSearchText(state: IspecialistState, searchText: string) {
      state.searchText = searchText;
    },
    setSearchHistory(state: IspecialistState, searchText: string) {
      if (!searchText) {
        return;
      }
      let { searchHistory } = state;
      searchHistory = searchHistory.filter((val: string) => val !== searchText);
      searchHistory.unshift(searchText);
      state.searchHistory = searchHistory;
    },
    clearSearchHistory(state: IspecialistState) {
      state.searchHistory = [];
    }
  }
};

const { dispatch, commit } = getStoreAccessors<IspecialistState, {}>(SPECIALIST);
const { actions, mutations } = specialist;
const {
  getHomePageInfo,
  getSpecialistDetail,
  followSpecialist,
  unfollowSpecialist,
  searchSpecialist,
  getRegionList,
  getHotCity,
  getDepartmentList,
  getSearchConditionList,
  getFollowedSpecialistList,
  startConsult,
  payConsult,
  fastInquiryPay,
  fastInquiryCancelConsult,
  getRecommendSpecialists,
  departmentDoctorSearch,
  getIMRecommendSpecialists,
  getLocation,
  getHospitalsType,
  getHospitalDeptSpecialists,
  getHospitalDetail,
  getHospitalDepts,
  getHospitalList,
  getCoinRechargeInfo,
  fetchGetConsultQueryQuickConsultStatus,
  groupDoctorSearch,
  placeOrder,
  placeFastInquiryOrder,
  getSpecialistPacks,
  getSpecialistPaidPacks,
  getEquityPackDetail,
  startConsultV2
} = actions;
const { setSearchText, setSearchHistory, setSpecialistDetail, clearSearchHistory, updateSpecialistDetail } = mutations;

export const dispatchGetCoinRechargeInfo = dispatch(getCoinRechargeInfo);
export const dispatchGetHomePageInfo = dispatch(getHomePageInfo);
export const dispatchGetSpecialistDetail = dispatch(getSpecialistDetail);
export const dispatchFollowSpecialist = dispatch(followSpecialist);
export const dispatchUnfollowSpecialist = dispatch(unfollowSpecialist);
export const dispatchSearchSpecialist = dispatch(searchSpecialist);
export const dispatchGetRegionList = dispatch(getRegionList);
export const dispatchGetHotCity = dispatch(getHotCity);
export const dispatchGetLocation = dispatch(getLocation);
export const dispatchGetHospitalsType = dispatch(getHospitalsType);
export const dispatchGetDepartmentList = dispatch(getDepartmentList);
export const dispatchStartConsult = dispatch(startConsult);
export const dispatchPayConsult = dispatch(payConsult);
export const dispatchFastInquiryPay = dispatch(fastInquiryPay);
export const dispatchFastInquiryCancelConsult = dispatch(fastInquiryCancelConsult);
export const dispatchGetPayInfo = dispatch(fetchGetConsultQueryQuickConsultStatus);
export const dispatchGetRecommendSpecialists = dispatch(getRecommendSpecialists);
export const dispatchDepartmentDoctorSearch = dispatch(departmentDoctorSearch);
export const dispatchGetIMRecommendSpecialists = dispatch(getIMRecommendSpecialists);
export const dispatchGetHospitalDeptSpecialists = dispatch(getHospitalDeptSpecialists);
export const dispatchGetHospitalDetail = dispatch(getHospitalDetail);
export const dispatchGetHospitalDepts = dispatch(getHospitalDepts);
export const dispathGroupDoctorSearch = dispatch(groupDoctorSearch);
export const dispatchPlaceOrder = dispatch(placeOrder);
export const dispatchPlaceFastInquiryOrder = dispatch(placeFastInquiryOrder);

export const dispatchGetSearchConditionList = dispatch(getSearchConditionList);
export const dispatchGetFollowedSpecialistLists = dispatch(getFollowedSpecialistList);
export const dispatchGetHospitalList = dispatch(getHospitalList);

export const dispatchGetSpecialistPacks = dispatch(getSpecialistPacks);
export const dispatchGetSpecialistPaidPacks = dispatch(getSpecialistPaidPacks);
export const dispatchGetEquityPackDetail = dispatch(getEquityPackDetail);
export const dispatchStartConsultV2 = dispatch(startConsultV2);

export const commitSetSearchText = commit(setSearchText);
export const commitSetSearchHistory = commit(setSearchHistory);
export const commitClearSearchHistory = commit(clearSearchHistory);
export const commitSetSetSpecialistDetail = commit(setSpecialistDetail);
export const commitUpdateSpecialistDetail = commit(updateSpecialistDetail);

export default specialist;
